import { QueryFeature } from '../../../../../config/queryClient';

enum QueryKey {
  MySettings = 'MySettings',
}

export const queryKeys = {
  mySettings: () => [QueryFeature.Settings, QueryKey.MySettings],
};
